export const V2Type = {
  Number: 'number',
  Artifact: 'artifact',
  Npi: 'npi',
  Reference: 'reference',
};

export const STATUS_CONFIG = {
  pending_verification: {
    label: 'Pending Verification',
    color: '#307F92',
  },
  /**
   * @deprecated Temporary status: backend should return 'pending_verification' instead of 'pending'
   */
  pending: {
    label: 'Pending Verification',
    color: '#307F92',
  },
  verified: { label: 'Verified', color: '#28a745' },
  invalid: { label: 'Invalid', color: '#d32f2f' },
  expired: { label: 'Expired', color: '#d32f2f' },
};

export const getStatusConfig = (status) =>
  STATUS_CONFIG[status] || { label: '-', color: '#6c757d' };


export const CredentialV2Enum  = {
  StateLicense: 'state_license',
  LocalAnesthesiaLicense: 'local_anesthesia_license',
  CprBls: 'cpr_bls',
  Reference: 'reference',
  Upload: 'upload',
  Npi: 'npi',
  // artifacts
  EFDACertification: 'efda_certification',
  DACertification: 'da_certification',
  Radiology: 'radiology',
  LocalAnesthesiaCertification: 'local_anesthesia_certification',
  CoronalPolishingCertification: 'coronal_polishing_certification',
  InfectionControlCertification: 'infection_control_certification',
  NitrousOxideCertification: 'nitrous_oxide_certification',
}

export const CREDENTIAL_V2_VALUES = Object.values(CredentialV2Enum);

export const getCredentialType = (
  credential
) => (
    CREDENTIAL_V2_VALUES.find((value) => credential.includes(value)) ||
    credential
  );